module.exports = __webpack_public_path__ + "static/img/32.30e104b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/32.png
// module id = /3hW
// module chunks = 1